import { render, staticRenderFns } from "./PayArrangeFatalError.vue?vue&type=template&id=6c173ffe&scoped=true&"
import script from "./PayArrangeFatalError.vue?vue&type=script&lang=js&"
export * from "./PayArrangeFatalError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c173ffe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c173ffe')) {
      api.createRecord('6c173ffe', component.options)
    } else {
      api.reload('6c173ffe', component.options)
    }
    module.hot.accept("./PayArrangeFatalError.vue?vue&type=template&id=6c173ffe&scoped=true&", function () {
      api.rerender('6c173ffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/payarrange/PayArrangeFatalError.vue"
export default component.exports